import moment from "moment";
import {
  getAreasWithSixHourForecast,
  fishing_ground_get_area_forecast_detail,
} from "../api/meteorologicalSea.js";
import { kvToJson } from "@/utils/dafaFormat.js";

import wind1 from "@/assets/images/swqx/wind/1.png";
import wind2 from "@/assets/images/swqx/wind/2.png";
import wind3 from "@/assets/images/swqx/wind/3.png";
import wind4 from "@/assets/images/swqx/wind/4.png";
import wind5 from "@/assets/images/swqx/wind/5.png";
import wind6 from "@/assets/images/swqx/wind/6.png";
import wind7 from "@/assets/images/swqx/wind/7.png";
import wind8 from "@/assets/images/swqx/wind/8.png";
import wind9 from "@/assets/images/swqx/wind/9.png";
import wind10 from "@/assets/images/swqx/wind/10.png";
import wind11 from "@/assets/images/swqx/wind/11.png";
import wind12 from "@/assets/images/swqx/wind/12.png";

function isSameDay(date1, date2) {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

// canvas 绘制渔场/海区复合图标
async function createFishingGroundIconImage(map, timestrap, dataList = [], colors) {
  const images = {
    1: wind1,
    2: wind2,
    3: wind3,
    4: wind4,
    5: wind5,
    6: wind6,
    7: wind7,
    8: wind8,
    9: wind9,
    10: wind10,
    11: wind11,
    12: wind12,
    "12-": wind12,
  };
  const promiseList = [];
  Object.keys(images).forEach((key) => {
    promiseList.push(
      new Promise((resolve) => {
        const src = images[key];
        images[key] = new Image();
        images[key].src = src;
        images[key].onload = () => resolve();
        images[key].onerror = () => resolve();
      }),
    );
  });
  await Promise.all(promiseList);

  // 按设备像素比放大绘制，避免高分屏下图标和文字模糊
  const dpr = Math.min(Math.max(window.devicePixelRatio || 1, 2), 3);
  const baseWidth = 169;
  const baseHeight = 57;

  const canvas = document.createElement("canvas");
  canvas.width = baseWidth * dpr;
  canvas.height = baseHeight * dpr;
  const ctx = canvas.getContext("2d");
  ctx.scale(dpr, dpr);
  // canvas 逻辑宽度（canvas.width 为物理像素）
  let canvasLogicalWidth = baseWidth;

  const imageCanvas = document.createElement("canvas");
  const rotateList = {
    北: 0,
    东北偏北: 30,
    东北: 45,
    东北偏东: 60,
    东: 90,
    东南偏东: 120,
    东南: 135,
    东南偏南: 150,
    南: 180,
    西南偏南: 210,
    西南: 225,
    西南偏西: 240,
    西: 270,
    西北偏西: 300,
    西北偏北: 315,
  };

  function getImage(image, properties) {
    const size = 30 * dpr;
    imageCanvas.width = size;
    imageCanvas.height = size;
    const imageCtx = imageCanvas.getContext("2d");
    imageCtx.clearRect(0, 0, size, size);
    imageCtx.translate(size / 2, size / 2);
    imageCtx.rotate(
      (Math.PI / 180) * (rotateList[properties.windDirection] || 0),
    );
    imageCtx.translate(-size / 2, -size / 2);
    imageCtx.drawImage(image, 0, 0, size, size);
    const imageData = imageCtx.getImageData(0, 0, size, size);
    imageCtx.clearRect(0, 0, size, size);
    imageCtx.putImageData(imageData, 0, 0);
    return imageCanvas;
  }

  function createBackgroundContent(x, y, width, height, radius, colors, properties) {
    const color = colors.find(
      (item) => item.value.toString() === properties.windZLevel,
    );
    ctx.fillStyle = `${color?.color || colors[0]?.color || "#ffffff"}CC`;
    ctx.strokeStyle = "#FFFFFF";
    ctx.lineWidth = 2;
    const r = x + width;
    const b = y + height;
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(r - radius, y);
    ctx.quadraticCurveTo(r, y, r, y + radius);
    ctx.lineTo(r, y + height - radius);
    ctx.quadraticCurveTo(r, b, r - radius, b);
    ctx.lineTo(x + radius, b);
    ctx.quadraticCurveTo(x, b, x, b - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.beginPath();
    // 绘制左边圆形
    ctx.fillStyle = "#FFFFFF";
    ctx.arc(x, y + height / 2, height / 2 + 4, 0, Math.PI * 2);
    ctx.fill();
    ctx.closePath();

    if (properties.windZLevel) {
      const image = images[properties.windZLevel];
      if (image) {
        if (parseInt(properties.windZLevel) <= 4) {
          ctx.drawImage(image, x - 14, y - 5, 30, 30);
        } else {
          const imagev = getImage(image, properties);
          ctx.drawImage(imagev, x - 14, y - 2, 30, 30);
        }
      }
    }

    let text = "";
    if (properties.windZLevel === "12-") {
      text += "12级以上";
      text += "  ";
      text += properties.wave === "7-" ? "7米以上" : `${properties.wave}米`;
    } else {
      text += properties.windZLevel
        ? properties.windZLevel
            .split("-")
            .map((item) => `${item}级`)
            .join("~")
        : "";
      text += "  ";
      text += `${properties.wave}米`;
    }
    ctx.fillStyle = "#000000";
    ctx.textAlign = "left";
    ctx.textBaseline = "bottom";
    ctx.font = "bold 14px 微软雅黑";
    ctx.fillText(text, x + 25, y + 19);
  }

  function createName(name) {
    ctx.strokeStyle = "#FFFFFF";
    ctx.lineWidth = 2;
    ctx.fillStyle = "#000000";
    ctx.textAlign = "center";
    ctx.font = "normal 16px Microsoft YaHei";
    ctx.textBaseline = "bottom";
    const textWidth = ctx.measureText(name).width + 2;
    canvasLogicalWidth = Math.max(baseWidth, textWidth);
    const physicalWidth = Math.ceil(canvasLogicalWidth * dpr);
    if (canvas.width !== physicalWidth) {
      // 修改 canvas.width 会重置绘图上下文，需重新应用缩放
      canvas.width = physicalWidth;
      ctx.scale(dpr, dpr);
    }
    ctx.strokeStyle = "#FFFFFF";
    ctx.lineWidth = 2;
    ctx.fillStyle = "#000000";
    ctx.textAlign = "center";
    ctx.font = "normal 16px Microsoft YaHei";
    ctx.textBaseline = "bottom";
    ctx.strokeText(name, canvasLogicalWidth / 2, 20);
    ctx.fillText(name, canvasLogicalWidth / 2, 20);
  }

  for (let data of dataList) {
    ctx.clearRect(0, 0, 5000, 1000);
    createName(data.properties.name);
    if (canvasLogicalWidth > 170) {
      createBackgroundContent(
        canvasLogicalWidth / 2 - 70,
        26,
        150,
        24,
        12,
        colors,
        data.properties,
      );
    } else {
      createBackgroundContent(17, 26, 150, 24, 12, colors, data.properties);
    }
    const imgName = data.properties.code + timestrap;
    if (!map.hasImage(imgName)) {
      map.addImage(
        imgName,
        ctx.getImageData(0, 0, canvas.width, canvas.height),
        { pixelRatio: dpr },
      );
    }
  }
}

const listeners = {
  onMinClick: null,
};

export default {
  state: {
    fillColorExpressions: [],
    originOptions: {
      zoom: 3.4,
      center: [0, 0],
    },
    fishGround: {
      datetimeSet: [],
      marks: {},
      forecastData: {},
      datetimeList: [],
    },
    layerList: [
      {
        id: "ehh-fishing-ground-fill",
        type: "fill",
        source: "ehh-fishing-ground",
        layout: { visibility: "none" },
        paint: {
          "fill-opacity": ["case", ["has", "windZLevel"], 0.5, 0.5],
        },
      },
      {
        id: "ehh-fishing-ground-storke",
        type: "line",
        source: "ehh-fishing-ground",
        layout: { visibility: "none" },
        paint: {
          "line-color": "#FFFFFF",
          "line-width": 1,
        },
      },
      {
        id: "ehh-fishing-ground-name",
        type: "symbol",
        source: "ehh-fishing-ground",
        filter: ["all", ["==", "$type", "Point"]],
        layout: {
          "icon-image": ["concat", ["get", "code"], ["get", "timestrap"]],
          "icon-size": ["interpolate", ["exponential", 1], ["zoom"], 1, 0.3, 5, 1, 20, 1],
          "icon-pitch-alignment": "map",
          "icon-rotation-alignment": "map",
          visibility: "none",
        },
        paint: {},
        minzoom: 0,
      },
    ],
    weatherList: [],
    weatherData: {
      label: null,
      seaArea: null,
      value: null,
    },
    weatherShow: false,
    weatherLoading: false,
  },
  getters: {
    fishGroundWeatherList(state) {
      return state.weatherList;
    },
  },
  actions: {
    fishGroundShow({ state, dispatch }) {
      const map = window.map;
      if (!map) return;
      state.layerList.forEach((layer) => {
        if (map.getLayer(layer.id)) {
          map.setLayoutProperty(layer.id, "visibility", "visible");
        }
      });
      state.originOptions = {
        zoom: map.getZoom(),
        center: map.getCenter(),
      };
      dispatch("fishGroundAddListener");
    },
    fishGroundHide({ state, dispatch }) {
      const map = window.map;
      if (!map) return;
      state.layerList.forEach((layer) => {
        if (map.getLayer(layer.id)) {
          map.setLayoutProperty(layer.id, "visibility", "none");
        }
      });
      dispatch("fishGroundRemoveListener");
    },
    fishGroundInit({ state, rootState }, map) {
      if (!map || window.map !== map) return;
      if (!map.getSource("ehh-fishing-ground")) {
        map.addSource("ehh-fishing-ground", {
          type: "geojson",
          data: window.fishingGroundData || {
            type: "FeatureCollection",
            features: [],
          },
        });
      }
      state.layerList.forEach((layer) => {
        if (!map.getLayer(layer.id)) {
          map.addLayer({
            ...layer,
            layout: { ...layer.layout, visibility: "none" },
          });
          if (layer.type === "fill") {
            map.setPaintProperty(
              layer.id,
              "fill-color",
              rootState.meteorological.fillColorExpressions,
            );
          }
        }
      });
    },
    fishGroundDestroy({ state }, map) {
      if (!map || !map.getLayer) return;
      state.layerList.forEach((layer) => {
        if (map.getLayer(layer.id)) {
          map.removeLayer(layer.id);
        }
      });
      if (map.getSource("ehh-fishing-ground")) {
        map.removeSource("ehh-fishing-ground");
      }
    },
    fishGroundGetData({ state, rootState }) {
      return new Promise((resolve, reject) => {
        getAreasWithSixHourForecast({ needAreaFields: 1 })
          .then((data) => {
            // h5 的 getAreasWithSixHourForecast 已通过 transformResponse 处理
            // 返回 {dataset, datetimeList, responseData}
            const xAxisData = {};
            let lastDay = new Date("1970-01-01");
            (data.datetimeList || []).forEach((key) => {
              const _key = Number(key);
              if (isSameDay(lastDay, new Date(_key))) {
                xAxisData[_key] = "";
              } else {
                const weekday = [
                  "周日",
                  "周一",
                  "周二",
                  "周三",
                  "周四",
                  "周五",
                  "周六",
                ];
                const date = new Date(_key);
                xAxisData[_key] = `${weekday[date.getDay()]} ${moment(_key).format("MM-DD")}`;
                lastDay = date;
              }
            });
            state.fishGround = {
              min: Number(data.datetimeList[0]),
              max: Number(data.datetimeList[data.datetimeList.length - 1]),
              marks: xAxisData,
              forecastData: data.dataset,
              datetimeList: data.datetimeList,
            };
            rootState.meteorological.activeData = state.fishGround;
            resolve(state.fishGround);
          })
          .catch((e) => reject(e));
      });
    },
    fishGroundOnChange({ state, rootState }, val) {
      const map = window.map;
      if (!map || !map.getSource("ehh-fishing-ground")) return;
      const codes = Object.keys(state.fishGround.forecastData);
      const values = Object.values(state.fishGround.forecastData);
      const features = map.getSource("ehh-fishing-ground")._data.features;
      const time = state.fishGround.datetimeList.find(
        (item) => Number(item) >= Number(val),
      );
      features.forEach((item) => {
        const index = codes.findIndex((code) => item.properties.code === code);
        if (index !== -1) {
          item.properties = Object.assign(item.properties, values[index][time]);
          item.properties.timestrap = time;
        }
      });
      createFishingGroundIconImage(
        map,
        time,
        features.filter((item) => item.geometry.type === "Point"),
        rootState.meteorological.colors,
      ).then(() => {
        map.getSource("ehh-fishing-ground").setData({
          type: "FeatureCollection",
          features,
        });
      });
    },
    fishGroundAddListener({ dispatch }) {
      const map = window.map;
      if (!map) return;
      listeners.onMinClick = (e) => {
        const data = e.features[0].toJSON().properties;
        dispatch("fishGroundHandleResultClick", {
          label: data.code,
          value: data.code,
          seaArea: data.name,
        });
      };
      map.on("click", "ehh-fishing-ground-fill", listeners.onMinClick);
    },
    fishGroundRemoveListener() {
      const map = window.map;
      if (!map) return;
      if (listeners.onMinClick) {
        map.off("click", "ehh-fishing-ground-fill", listeners.onMinClick);
      }
    },
    fishGroundHandleResultClick({ state }, row) {
      state.weatherData = row;
      state.weatherShow = true;
      state.weatherLoading = true;
      fishing_ground_get_area_forecast_detail({ areaCode: row.value })
        .then((response) => {
          const result = response?.result || response?.data || {};
          const element = result.forecasts || [];
          const list = [];
          const size = 4;
          for (let i = 0; i < element.length; i += size) {
            list.push(element.slice(i, i + size));
          }
          state.weatherList = list;
          state.weatherLoading = false;
        })
        .catch(() => {
          state.weatherLoading = false;
        });
    },
    fishGroundClose({ state }) {
      state.weatherShow = false;
    },
  },
};
